import { useConstructionStore } from "@/stores/construction"

export function useConstruction() {
  const { getCloudConstruction } = useConstructionStore()

  const loadConstruction = async (cloudConstructionId: string) => {
    const cloudConstructionInfo = await getCloudConstruction({ cloud_construction_id: cloudConstructionId })
    if (cloudConstructionInfo) return cloudConstructionInfo
    // 工事情報取得でエラーの場合
    throw new Error("工事情報を取得できない")
  }

  return {
    loadConstruction
  }
}
